import React from "react";
import { Mail, MapPin } from "lucide-react";
import { brand, navHrefs, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { lang } = useLang();
  const f = translations[lang].footer;

  return (
    <footer className="bg-navy text-blue-100">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <div className="inline-flex bg-white rounded-xl px-3 py-2"><img src={brand.logo} alt="CMED.AI" className="h-8 w-auto" /></div>
          <p className="mt-4 text-sm text-blue-200/80 max-w-sm leading-relaxed">{f.blurb}</p>
          <div className="mt-6 space-y-2 text-sm">
            <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-blue-300" /> {f.address}</p>
            <a href={`mailto:${brand.email}`} className="flex items-center gap-2 hover:text-white transition-colors"><Mail className="h-4 w-4 text-blue-300" /> {brand.email}</a>
          </div>
        </div>
        {f.columns.map((col, ci) => (
          <div key={ci}>
            <h4 className="font-display font-bold text-white">{col.title}</h4>
            <ul className="mt-4 space-y-3">
              {col.links.map((l, li) => (<li key={li}><a href={ci === 1 ? navHrefs[[0,2,5,5][li]] : "#"} className="text-sm text-blue-200/80 hover:text-white transition-colors">{l}</a></li>))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-blue-200/70">© {new Date().getFullYear()} {brand.name}. {f.rights}</p>
          <p className="text-xs text-blue-200/60">{f.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
}
